import type { CustomEventsContext } from '../types'

export default function (this: CustomEventsContext) {
  this.sendEvent('close', {})
}
